export default [
  {
    name: "noticeList",
    path: "/noticeModel/noticeList",
    component: () => import("@/views/noticeModel/noticeList.vue"),
    meta: {
      title: "通知公告列表",
    },
  },
  {
    name: "noticeDetail",
    path: "/noticeModel/noticeDetail",
    component: () => import("@/views/noticeModel/noticeDetail.vue"),
    meta: {
      parentAuth: "/noticeModel/noticeList",
      title: "新建通知公告",
    },
  },
  {
    name: "noticeDetailEdit",
    path: "/noticeModel/noticeDetailEdit",
    component: () => import("@/views/noticeModel/noticeDetail.vue"),
    meta: {
      parentAuth: "/noticeModel/noticeList",
      title: "编辑通知公告",
    },
  },
  {
    name: "noticeDetailView",
    path: "/noticeModel/noticeDetailView",
    component: () => import("@/views/noticeModel/noticeDetail.vue"),
    meta: {
      parentAuth: "/noticeModel/noticeList",
      title: "查看通知公告",
    },
  },
  {
    name: "newNoticeList",
    path: "/noticeModel/newNoticeList",
    component: () => import("@/views/noticeModel/newNotice/index.vue"),
    meta: {
      title: "通知管理列表",
    },
  },
  {
    name: "MessageTypeList",
    path: "/noticeModel/MessageTypeList",
    component: () => import("@/views/noticeModel/newNotice/MessageTypeList.vue"),
    meta: {
      title: "消息配置",
    },
  },
  {
    name: "noticeFormDetail",
    path: "/noticeModel/formDetail",
    component: () => import("@/views/noticeModel/newNotice/components/formDetail.vue"),
    meta: {
      parentAuth: "/noticeModel/newNoticeList",
      title: "新建通知",
    },
  },
  {
    name: "groupFormDetail",
    path: "/noticeModel/groupFormDetail",
    component: () => import("@/views/noticeModel/newNotice/components/groupFormDetail.vue"),
    meta: {
      parentAuth: "/noticeModel/newNoticeList",
      title: "群通知",
    },
  },
];
